import type { Filter, SpreadsheetDefinition } from 'common/types/summaryDefinitions';

export type WorkboardGroupBy = 'companies';

export interface WorkboardTableDefinition {
  columns: Record<number, string>;
  sortKeys: SpreadsheetDefinition['sortKeys'];
  groupBy: WorkboardGroupBy;
  filters: Filter[];
  filterExclusions?: string[];
  columnWidths?: { column: string; width: number }[];
}

export const WORKBOARD_TABLE_VIEWS_QUERY_KEY = ['workboard-table-views', 'models'] as const;

export const WORKBOARD_VIEWS_MIGRATED_KEY = 'workboard-models-views-migrated';

// Meta filter column ids — not real table columns; used only in table_definition.filters
export const WORKBOARD_META_COLUMNS = {
  ASSIGNMENT: '_workboard_assignment',
  TRAILING_DATES: '_workboard_trailing_dates',
} as const;
